import { css } from '@linaria/core';
import { defaultFocusStyles } from '@terveystalo/design-system-theme';
/**
 * Function which generates basic focus-visible style blocks with backwards support
 * for browsers without focus-visible support.
 *
 * @example Usage within Linaria
 * ```
 *  const styles = css`
 *    background-color: blue;
 *    ${focusVisible(`outline: 1px solid red;`, `outline: 0;`)}
 *  `
 * ```
 *
 * @param focusStyles styles for defining focus-visible (and focus) styles
 * @param resetFocusStyles styles which are used to reset the focus styles for browsers
 * which support also focus-visible
 */
export const focusVisible = (focusStyles, resetFocusStyles) => `
  &:focus {
    ${focusStyles}
  }
  &:focus:not(:focus-visible) {
    ${resetFocusStyles}
  }
  &:focus-visible {
    ${focusStyles}
  }
`;
/**
 * Transform the default focus styles into a shared Linaria class name.
 */
export const focusBoxShadow = css `
  ${defaultFocusStyles}
`;


import "../../css/css-utils/focus-visible.css";
